import image0 from '../assets/players/flustered/Aegis.webp';
import image1 from '../assets/players/flustered/Beep.webp';
import image2 from '../assets/players/flustered/Ben.webp';
import image3 from '../assets/players/flustered/Bits.webp';
import image4 from '../assets/players/flustered/Boo.webp';
import image5 from '../assets/players/flustered/Buck.webp';
import image6 from '../assets/players/flustered/Cactus.webp';
import image7 from '../assets/players/flustered/Clank.webp';
import image8 from '../assets/players/flustered/Don.webp';
import image9 from '../assets/players/flustered/Dust.webp';
import image10 from '../assets/players/flustered/Ember.webp';
import image11 from '../assets/players/flustered/Ethan.webp';
import image12 from '../assets/players/flustered/Fan.webp';
import image13 from '../assets/players/flustered/Fang.webp';
import image14 from '../assets/players/flustered/Flap.webp';
import image15 from '../assets/players/flustered/Groan.webp';
import image16 from '../assets/players/flustered/Howl.webp';
import image17 from '../assets/players/flustered/Jade.webp';
import image18 from '../assets/players/flustered/Kong.webp';
import image19 from '../assets/players/flustered/Lotus.webp';
import image20 from '../assets/players/flustered/Mimic.webp';
import image21 from '../assets/players/flustered/Nib.webp';
import image22 from '../assets/players/flustered/Nova.webp';
import image23 from '../assets/players/flustered/Pearl.webp';
import image24 from '../assets/players/flustered/Pew.webp';
import image25 from '../assets/players/flustered/Pip.webp';
import image26 from '../assets/players/flustered/Plop.webp';
import image27 from '../assets/players/flustered/Pot.webp';
import image28 from '../assets/players/flustered/Puff.webp';
import image29 from '../assets/players/flustered/Rattle.webp';
import image30 from '../assets/players/flustered/Rune.webp';
import image31 from '../assets/players/flustered/Sage.webp';
import image32 from '../assets/players/flustered/Snap.webp';
import image33 from '../assets/players/flustered/Thorn.webp';
import image34 from '../assets/players/flustered/Tusk.webp';
import image35 from '../assets/players/flustered/Twig.webp';
import image36 from '../assets/players/flustered/Viking.webp';
import image37 from '../assets/players/flustered/Void.webp';
import image38 from '../assets/players/flustered/Wisp.webp';
import image39 from '../assets/players/flustered/Zzz.webp';
const tournamentFlusteredImages = {
  'Aegis': image0,
  'Beep': image1,
  'Ben': image2,
  'Bits': image3,
  'Boo': image4,
  'Buck': image5,
  'Cactus': image6,
  'Clank': image7,
  'Don': image8,
  'Dust': image9,
  'Ember': image10,
  'Ethan': image11,
  'Fan': image12,
  'Fang': image13,
  'Flap': image14,
  'Groan': image15,
  'Howl': image16,
  'Jade': image17,
  'Kong': image18,
  'Lotus': image19,
  'Mimic': image20,
  'Nib': image21,
  'Nova': image22,
  'Pearl': image23,
  'Pew': image24,
  'Pip': image25,
  'Plop': image26,
  'Pot': image27,
  'Puff': image28,
  'Rattle': image29,
  'Rune': image30,
  'Sage': image31,
  'Snap': image32,
  'Thorn': image33,
  'Tusk': image34,
  'Twig': image35,
  'Viking': image36,
  'Void': image37,
  'Wisp': image38,
  'Zzz': image39,
};

export default tournamentFlusteredImages;
